<div class="celo-cursor-pointer" (click)="onClick()">
  @if (type !== "TeamChat" || isRolesTab) {
    <app-celo-avatar
      [width]="40"
      [height]="40"
      [type]="type"
      [participant]="participantToShow ? participantToShow : ''"
      [showBadge]="participantToShow?.isExternal ? false : true"
      [conversationPictureUri]="
        !!conversation.photoId && leftChat ? conversationPictureUri : null
      "
    ></app-celo-avatar>
  } @else {
    <app-roles-icon></app-roles-icon>
  }
</div>
<div class="subject-text-section" (click)="onClick()">
  <div class="main-title celo-elipsis" data-testid="conversation-title">
    {{ name }}
    @if (type === "SelfChat") {
      <span> (You)</span>
    }
  </div>

  <div class="sub-title">
    @if (
      ((!canShowStatus || !userStatus) && !typing.length) ||
      (!allowedToShowLastOnline && !allowedToShowTyping)
    ) {
      <div class="appear_1">
        {{ subtitle }}
      </div>
    }
    @if (
      type === "Chat" && canShowStatus && userStatus && allowedToShowLastOnline
    ) {
      <div>
        @if (!typing.length) {
          <div class="appear_1">
            <app-celo-user-status
              [lastActiveOnUtc]="
                $safeNavigationMigration(userStatus?.updatedOnUtc)
              "
            ></app-celo-user-status>
          </div>
        }
      </div>
    }
    @if (typing.length > 0 && allowedToShowTyping) {
      <div class="appear_1 typing_text">
        @if (typing.length === 1) {
          <div>
            @if (type === "Chat") {
              <span>Typing...</span>
            }
            @if (type !== "Chat") {
              <span>{{ typing[0].firstName }} is typing...</span>
            }
          </div>
        }
        @if (typing.length === 2) {
          <div>
            {{ typing[0].firstName }} and {{ typing[1].firstName }} are
            typing...
          </div>
        }
        @if (typing.length === 3) {
          <div>
            {{ typing[0].firstName }}, {{ typing[1].firstName }} and
            {{ typing[2].firstName }} are typing...
          </div>
        }
        @if (typing.length > 3) {
          <div>{{ typing.length }} people are typing...</div>
        }
      </div>
    }
  </div>
</div>
<div class="icons">
  @if (isOpened) {
    <div>
      <button mat-icon-button (click)="close()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  }
  @if (!isOpened) {
    <div>
      @if (userLimits$ | async; as userLimits) {
        @if ((isStartVideoCallUiEnabled$ | async) && isCallAvailable) {
          <button mat-icon-button (click)="call(userLimits)">
            <mat-icon svgIcon="video-on"></mat-icon>
          </button>
        }
      }
      <button
        mat-icon-button
        aria-label="Search conversation"
        (click)="search()"
      >
        <mat-icon>search</mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Conversation info"
        (click)="openInfo()"
      >
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>
  }
</div>
